import topRbottomL from "./topRbottomL";

function topLbottomR(
  index,
  matrixOfPawns,
  boardData,
  tempArray,
  allWays,
  recursiveCount,
  prevSquareIndex,
  tempArrayallDirec,
  allDirections,
  playerTurn
) {
  const directions = [
    { row: -1, col: -1 }, // Top-left
    { row: 1, col: 1 }, // Bottom-right
  ];

  if (tempArray.length === 0) {
    if (prevSquareIndex > index) {
      var directionindex = -9;
    } else {
      var directionindex = 9;
    }
  } else {
    if (tempArray[tempArray.length - 1] < index) {
      var directionindex = 9;
    } else {
      var directionindex = -9;
    }
  }
  while (
    ((boardData[index][0] === 0 ||
      boardData[index][0] === 1 ||
      boardData[index][0] === 31) &&
      playerTurn === 2) ||
    ((boardData[index][0] === 0 ||
      boardData[index][0] === 2 ||
      boardData[index][0] === 32) &&
      playerTurn === 1)
  ) {
    if (
      [
        1, 3, 5, 7, 9, 10, 30, 50, 70, 90, 92, 94, 96, 98, 29, 49, 69, 89,
      ].includes(index) &&
      boardData[index][0] !== 0
    ) {
      break;
    } else if (
      (boardData[index][0] === 1 &&
        boardData[index + directionindex][0] !== 0 &&
        !tempArray.includes(boardData[index + directionindex][0]) &&
        playerTurn === 2) ||
      (boardData[index][0] === 2 &&
        boardData[index + directionindex][0] !== 0 &&
        !tempArray.includes(boardData[index + directionindex][0]) &&
        playerTurn === 1)
    ) {
      break;
    } else if (
      ((boardData[index][0] === 1 || boardData[index][0] === 31) &&
        playerTurn === 2) ||
      ((boardData[index][0] === 2 || boardData[index][0] === 32) &&
        playerTurn === 1)
    ) {
      tempArray.push(index);
      const newArray = [...tempArray];
      allWays.push(newArray);
      if (directionindex === 9) {
        tempArrayallDirec.push([1, -1]);
      } else {
        tempArrayallDirec.push([-1, 1]);
      }
      const newArrayallDirec = [...tempArrayallDirec];
      allDirections.push(newArrayallDirec);
    } else {
      const row = Math.floor(index / 10);
      const col = index % 10;
      for (const direction of directions) {
        let i = row + direction.row;
        let j = col + direction.col;

        let ifHandelPlusPlus = true;
        while (
          i >= 0 &&
          i < matrixOfPawns.length &&
          j >= 0 &&
          j < matrixOfPawns[i].length &&
          ifHandelPlusPlus === true
        ) {
          let indexPawn = matrixOfPawns[i][j];
          let nextPawn = boardData[matrixOfPawns[i][j]][0];
          if (
            [
              1, 3, 5, 7, 9, 10, 30, 50, 70, 90, 92, 94, 96, 98, 29, 49, 69, 89,
            ].includes(indexPawn)
          ) {
            ifHandelPlusPlus = false;
            break;
          }

          if (
            matrixOfPawns[i + direction.row][j + direction.col] !== undefined
          ) {
            var nextNextPawn =
              boardData[matrixOfPawns[i + direction.row][j + direction.col]][0];
            var nextNextPawnIndex =
              matrixOfPawns[i + direction.row][j + direction.col];
            if (playerTurn === 2) {
              if (
                (nextPawn === 1 &&
                  nextNextPawn === 1 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                (nextPawn === 1 &&
                  nextNextPawn === 31 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                (nextPawn === 31 &&
                  nextNextPawn === 1 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                (nextPawn === 31 &&
                  nextNextPawn === 31 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                (nextPawn === 1 &&
                  nextNextPawn === 2 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                nextPawn === 2 ||
                nextPawn === 32
              ) {
                ifHandelPlusPlus = false;
                break;
              }
            } else if (playerTurn === 1) {
              if (
                (nextPawn === 2 &&
                  nextNextPawn === 2 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                (nextPawn === 2 &&
                  nextNextPawn === 32 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                (nextPawn === 32 &&
                  nextNextPawn === 2 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                (nextPawn === 32 &&
                  nextNextPawn === 32 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                (nextPawn === 2 &&
                  nextNextPawn === 1 &&
                  !tempArray.includes(nextNextPawnIndex)) ||
                nextPawn === 1 ||
                nextPawn === 31
              ) {
                ifHandelPlusPlus = false;
                break;
              }
            }
          }

          if (ifHandelPlusPlus) {
            if (
              ((nextPawn === 1 || nextPawn === 31) &&
                (nextNextPawn === 0 ||
                  nextNextPawn === 32 ||
                  (nextNextPawn === 1 &&
                    tempArray.includes(nextNextPawnIndex))) &&
                playerTurn === 2) ||
              ((nextPawn === 2 || nextPawn === 32) &&
                (nextNextPawn === 0 ||
                  nextNextPawn === 31 ||
                  (nextNextPawn === 2 &&
                    tempArray.includes(nextNextPawnIndex))) &&
                playerTurn === 1)
            ) {
              if (tempArray.includes(indexPawn)) {
                break;
              }
              if (!tempArray.includes(indexPawn)) {
                tempArray.push(indexPawn);
                tempArrayallDirec.push([direction.row, direction.col]);
                recursiveCount += 1;
              }
              i += direction.row;
              j += direction.col;
              indexPawn = matrixOfPawns[i][j];
              topRbottomL(
                indexPawn,
                matrixOfPawns,
                boardData,
                tempArray,
                allWays,
                recursiveCount,
                prevSquareIndex,
                tempArrayallDirec,
                allDirections,
                playerTurn
              );
              recursiveCount -= 1;
              const newArray = [...tempArray];
              const newArrayallDirec = [...tempArrayallDirec];
              allWays.push(newArray);
              allDirections.push(newArrayallDirec);
              tempArray.pop();
              tempArrayallDirec.pop();
              if (recursiveCount + 1 < tempArray.length) {
                while (recursiveCount + 1 !== tempArray.length) {
                  tempArray.pop();
                  tempArrayallDirec.pop();
                }
              }
              break;
            }
          }
          i += direction.row;
          j += direction.col;
        }
      }
    }
    index += directionindex;

    if (index < 1 || index > 98) {
      break;
    }
  }

  return { allWays: allWays, allDirections: allDirections };
}
export default topLbottomR;
